import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
import firebase from './firebase';
import { FirebaseAuth } from 'react-firebaseui';
import 'typeface-roboto';
import Reboot from 'material-ui/Reboot';
import Button from 'material-ui/Button';
import AppBar from 'material-ui/AppBar';
import Toolbar from 'material-ui/Toolbar';
import Typography from 'material-ui/Typography';
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import List, { ListItem, ListItemText, ListSubheader } from 'material-ui/List';
import FormDialog from './FormDialog';
import SelectableList from './SelectableList';
import Drawer from 'material-ui/Drawer';
const Fragment = React.Fragment;

const db = firebase.firestore();

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { loginStatus: 'unknown', currentUser: null };
    this.title = "Volleyball Scheduler";
    this.uiConfig = {
      signInFlow: 'popup',
      signInOptions: [
        {
          provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
          authMethod: 'https://accounts.google.com',
          clientId: '652622990691-ci53u9e41fd1lj0kcjjdc0eggj6tfhqd.apps.googleusercontent.com',
          customParameters: {
            prompt: 'select_account'
          }
        },
        firebase.auth.EmailAuthProvider.PROVIDER_ID
      ],
      callbacks: {
        signInSuccess: user => {
          db.collection('users').doc(user.uid).set({}, { merge: true });
          //this.setState({ signedIn: true });
          return false;
        }
      },
      credentialHelper: 'googleyolo'
    };

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        //console.log(`${user.displayName} logged in`);
        this.setState({ loginStatus: 'loggedin', currentUser: user });
      }
      else {
        //console.log('Not logged in');
        this.setState({ loginStatus: 'loggedout', currentUser: null });
      }
    });
  }

  handleSignOut = () => {
    firebase.auth().signOut();
  }

  selectUi = status => {
    switch (status)
    {
      case 'loggedin':
        return <MainUi />
      case 'loggedout':
        return <FirebaseAuth uiConfig={this.uiConfig} firebaseAuth={firebase.auth()} />
      case 'unknown':
      default:
        return ''; // We need this case because if we're not logged in we don't want to show the main UI, but
                   // at the same time even when logged in the state is briefly indeterminate and causes the
                   // Auth UI to load the CredentialHelper
    }
  }

  render() {
    return (
      <div className="top">
        <Reboot />
        <AppBar position="static">
          <Toolbar>
            <Typography variant="title" color="inherit" className="flex">
              {this.title}
            </Typography>
            <Typography variant="subheading" color="inherit" style={{ padding: '0.5em' }}>
              {(this.state.loginStatus === "loggedin") ? `Logged in as ${this.state.currentUser.displayName}` : 'Not logged in.' }
            </Typography>
            {(this.state.loginStatus === "loggedin") ? <Fragment><Typography variant="display1" color="inherit">|</Typography><Button color="inherit" onClick={this.handleSignOut}>Logout</Button></Fragment> : ''}
          </Toolbar>
        </AppBar>
        {(this.state.loginStatus === "loggedin") ? '' : <h1 align="center">Welcome to Volleyball Scheduler!</h1>}
        {this.selectUi(this.state.loginStatus)}
      </div>
    );
  }
}

class MainUi extends Component {
  constructor(props) {
    super(props);
    this.state = { messages: [], players: [], teams: [], playerInfo: [], teamInfo: [], selectedPlayers: [], selectedTeams: [] };
  }

  componentDidMount() {
    this.unsubscribePlayersChanged = db.collection('players').orderBy('name').onSnapshot(this.handlePlayersChanged);
    this.unsubscribeTeamsChanged = db.collection('teams').orderBy('name').onSnapshot(this.handleTeamsChanged);
  }

  componentWillUnmount() {
    this.unsubscribePlayersChanged();
    this.unsubscribeTeamsChanged();
  }

  handlePlayersChanged = snapshot => {
    let players = this.state.players.slice();
    snapshot.docChanges.forEach(change => {
      switch (change.type)
      {
        case "added":
          let newItem = { id: change.doc.id, name: change.doc.get('name'), number: change.doc.get('number') };
          players.splice(change.newIndex, 0, newItem);
          break;
        case "removed":
          players.splice(change.oldIndex, 1);
          break;
        case "modified":
          let oldPlayer = players.splice(change.oldIndex, 1)[0];
          oldPlayer.name = change.doc.get('name');
          oldPlayer.number = change.doc.get('number');
          // The player ID is a unique auto-generated ID so it can't change, no need to update it
          players.splice(change.newIndex, 0, oldPlayer);
          break;
        default:
          break;
      }
    });
    this.setState({ players: players, selectedPlayers: this.state.selectedPlayers.filter(player => players.map(p => p.id).includes(player)) });
  }

  handleTeamsChanged = snapshot => {
    let teams = this.state.teams.slice();
    snapshot.docChanges.forEach(change => {
      switch (change.type)
      {
        case "added":
          let newItem = { id: change.doc.id, name: change.doc.get('name') };
          teams.splice(change.newIndex, 0, newItem);
          break;
        case "removed":
          teams.splice(change.oldIndex, 1);
          break;
        case "modified":
          let oldTeam = teams.splice(change.oldIndex, 1)[0];
          oldTeam.name = change.doc.get('name');
          oldTeam.number = change.doc.get('number');
          // The team ID is a unique auto-generated ID so it can't change, no need to update it
          teams.splice(change.newIndex, 0, oldTeam);
          break;
        default:
          break;
      }
    });
    this.setState({ teams: teams, selectedTeams: this.state.selectedTeams.filter(team => teams.map(t => t.id).includes(team)) });
  }

  handleAssignPlayersClick = async e => {
    let batch = db.batch();
    this.state.selectedTeams.forEach(team => {
      batch.update(db.collection('teams').doc(team), Object.assign({}, ...this.state.selectedPlayers.map(player => {return {[`roster.${player}`]: true}})));
    });
    await batch.commit();
  }

  handleAddPlayerSubmit = async (playerName, playerNumber) => {
    await db.collection('players').add({ name: playerName, number: playerNumber });
  }

  handleRemovePlayers = async () => {
    let teams = await db.collection('teams').get();
    let batch = db.batch();
    this.state.selectedPlayers.forEach(player => {
      batch.delete(db.collection('players').doc(player));
      teams.forEach(async team => {
        batch.update(db.collection('teams').doc(team.ref.id), { [`roster.${player}`]: firebase.firestore.FieldValue.delete() });
      });
    });
    await batch.commit();
  }

  handleRemoveTeams = async () => {
    let batch = db.batch();
    this.state.selectedTeams.forEach(team => {
      batch.delete(db.collection('teams').doc(team));
    });
    await batch.commit();
  }

  handleAddTeamSubmit = async teamName => {
    await db.collection('teams').add({ name: teamName, roster: {} });
  }

  handleSelectedPlayersChange = e => {
    this.setState({ selectedPlayers: e.target.selectedItems });
  }

  handleSelectedTeamsChange = e => {
    this.setState({ selectedTeams: e.target.selectedItems });
  }

  handlePlayerInfoClick = async e => {
    let playerId = e.target.clickedItemValue;
    let teams = await db.collection('teams').where(`roster.${playerId}`, '==', true).get();
    this.setState({ playerInfo: teams.docs.map(team => { return { id: team.id, name: team.get('name') }; }) });
  }

  handleTeamInfoClick = async e => {
    let teamId = e.target.clickedItemValue;
    let team = await db.collection('teams').doc(teamId).get();
    this.setState({ selectedTeam: teamId, teamInfo: Object.keys(team.get('roster')).map(playerId => { return {id: playerId, name: this.state.players.find(p => p.id === playerId).name };})});
  }

  render() {
    const useGrid = false;
    if (useGrid) {
    return (
      <Grid container justify="center">
        <Grid item>
          <Paper>
            <Grid container>
              <Grid item xs={4}>
              <SelectableList items={this.state.players.map(player => { return { id: player.id, primary: player.name, secondary: `#${player.number}` }; })} subHeader="Players" onSelectionChanged={this.handlePlayerSelect} />
              </Grid>
              <Grid item xs={4}>
                <Button variant="raised" className="grid-center" title="Assign Player to Team" onClick={this.handleAssignPlayerClick}>>></Button>
              </Grid>
              <Grid item xs={4}>
                <SelectableList items={this.state.teams.map(team => { return { id: team.id, primary: team.name }; })} subHeader="Teams" onSelectionChanged={this.handleTeamSelect} />
              </Grid>
              <Grid item xs={4}>
                <FormDialog buttonText="Add Player" onSubmit={this.handleAddPlayerSubmit} />
              </Grid>
              <Grid item xs={4} />
              <Grid item xs={4}>
                <FormDialog buttonText="Add Team" onSubmit={this.handleAddTeamSubmit} />
              </Grid>
              <Grid item xs={4}>
                <Button variant="raised" color="secondary" onClick={this.handleRemovePlayer}>Remove Player</Button>
              </Grid>
              <Grid item xs={4} />
              <Grid item xs={4}>
                <Button variant="raised" color="secondary" onClick={this.handleRemoveTeams}>Remove Team</Button>
              </Grid>
              <Grid item xs={4}>
                <InfoList header="Player's teams:" items={this.state.playerInfo} />
              </Grid>
              <Grid item xs={4} />
              <Grid item xs={4}>
                <InfoList header="Team roster:" items={this.state.teamInfo} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    );
    } else {
      return (
      <Grid container justify="center">
        <Grid item>
          <Paper>
            <div className="grid">
              <SelectableList dense items={this.state.players.map(player => { return { id: player.id, primary: player.name, secondary: `#${player.number}` }; })} subHeader="Players" selectedItems={this.state.selectedPlayers} onSelectionChange={this.handleSelectedPlayersChange} onSecondaryActionClick={this.handlePlayerInfoClick} />
              <Button variant="raised" className="grid-center" title="Assign Players to Teams" onClick={this.handleAssignPlayersClick}>>></Button>
              <SelectableList dense items={this.state.teams.map(team => { return { id: team.id, primary: team.name }; })} subHeader="Teams" selectedItems={this.state.selectedTeams} onSelectionChange={this.handleSelectedTeamsChange} onSecondaryActionClick={this.handleTeamInfoClick} />
              <FormDialog buttonText="Add Player" onSubmit={this.handleAddPlayerSubmit} />
              <div className="blank"></div>
              <FormDialog buttonText="Add Team" onSubmit={this.handleAddTeamSubmit} />
              <Button variant="raised" color="secondary" onClick={this.handleRemovePlayers}>Remove Players</Button>
              <div className="blank"></div>
              <Button variant="raised" color="secondary" onClick={this.handleRemoveTeams}>Remove Teams</Button>
              <InfoList header="Player's teams:" items={this.state.playerInfo} />
              <div className="blank"></div>
              <InfoList header="Team roster:" items={this.state.teamInfo} />
            </div>
          </Paper>
        </Grid>
      </Grid>
    );
    }
  }
}

class InfoItem extends Component {
  render() {
    return <li>{this.props.text}</li>
  }
}

class InfoList extends Component {
  render() {
    const header = this.props.header;
    const items = this.props.items;
    return (
      <div>
        <label>{header}</label>
        <ul>
          {items.map(item =>
            <InfoItem key={item.id} text={item.name} />
          )}
        </ul>
      </div>
    );
  }
}

class SelectOption extends Component {
  render() {
    const value = this.props.value;
    const text = this.props.text;
    return <option value={value}>{text}</option>;
  }
}

class Select extends Component {
  render() {
    const items = this.props.items;
    const size = this.props.size;
    const multiple = this.props.multiple;
    return (
      <select size={size} multiple={multiple}>
        {items.map(item =>
          <SelectOption key={item.id} value={item.id} text={item.name} />
        )}
      </select>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx